import './loading.css';

export const Loading = () => {
  return (
    <div className="loading-animation">
      <div id="container">
        <p aria-label="Loading" className="loading-text">
          <span aria-hidden="true" className="letter">
            L
          </span>
          <span aria-hidden="true" className="letter">
            o
          </span>
          <span aria-hidden="true" className="letter">
            a
          </span>
          <span aria-hidden="true" className="letter">
            d
          </span>
          <span aria-hidden="true" className="letter">
            i
          </span>
          <span aria-hidden="true" className="letter">
            n
          </span>
          <span aria-hidden="true" className="letter">
            g
          </span>
        </p>
      </div>
    </div>
  );
};
